import { MetricValue } from 'components/RoasValue.jsx';
export default function Ticker({ label, value, color, small }) {
  return (
    <div className="v3-ticker-seg">
      <div>
        <div className="v3-ticker-lbl">{label}</div>
        <div
          className={`v3-ticker-val${small ? ' v3-ticker-val--sm' : ''}`}
          style={{ '--tick-color': color }}
        ><MetricValue label={label} value={value} /></div>
      </div>
    </div>
  );
}
